import { render, staticRenderFns } from "./explain.vue?vue&type=template&id=1fff0d0c&scoped=true&"
import script from "./explain.vue?vue&type=script&lang=js&"
export * from "./explain.vue?vue&type=script&lang=js&"
import style0 from "./explain.vue?vue&type=style&index=0&id=1fff0d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff0d0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fff0d0c')) {
      api.createRecord('1fff0d0c', component.options)
    } else {
      api.reload('1fff0d0c', component.options)
    }
    module.hot.accept("./explain.vue?vue&type=template&id=1fff0d0c&scoped=true&", function () {
      api.rerender('1fff0d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stockManage/components/explain.vue"
export default component.exports